<template>
<div>
    <!-- 收费规则 -->
		<el-dialog title="收费规则" :close-on-click-modal=false :lock-scroll=false :visible.sync="dialogFormVisibleRule" width="600px"  @open="openDialogRule" @close="closeDialogRule">
			<div>
				<el-form ref="formRule" label-position="right" :label-width="formLabelWidth">
					<!-- 室内 3-->
					<!-- <table v-if="matchRuleStype" class="table-rule">
						<tr>
							<td rowspan="3">小车</td>
							<td rowspan="2">工作日</td>
							<td>
								<el-time-picker
									:editable="false"
								    is-range
								    v-model="formRule.params[0].StartOrEndTime"
								    value-format="HH:mm" 
								    format="HH:mm"
								    range-separator="-"
								    start-placeholder=""
								    end-placeholder=""
								    placeholder="">
								</el-time-picker>

							</td>
							<td>首小时<input v-model="formRule.params[0].firstPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元,首小时后<input v-model="formRule.params[0].firstHoursPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/半小时</td>
						</tr>
						<tr>
							<td>
								{{formRule.params[0].StartOrEndTime[1]}} - 次日 {{formRule.params[0].StartOrEndTime[0]}}
							</td>
							<td><input v-model="formRule.params[0].odLastPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/时</td>
						</tr>
						<tr>
							<td>非工作日</td>
							<td colspan="2">首小时<input v-model="formRule.params[0].tdPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元,首小时后<input v-model="formRule.params[0].tdHoursPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/半小时</td>
						</tr>

						<tr>
							<td rowspan="3">大车</td>
							<td rowspan="2">工作日</td>
							<td>
								{{formRule.params[0].StartOrEndTime[0]}} - {{formRule.params[0].StartOrEndTime[1]}}
							</td>
							<td>首小时<input v-model="formRule.params[1].firstPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元,首小时后<input v-model="formRule.params[1].firstHoursPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/半小时</td>
						</tr>
						<tr>
							<td>
								{{formRule.params[0].StartOrEndTime[1]}} - 次日 {{formRule.params[0].StartOrEndTime[0]}}
							</td>
							<td><input v-model="formRule.params[1].odLastPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/时</td>
						</tr>
						<tr>
							<td>非工作日</td>
							<td colspan="2">首小时<input v-model="formRule.params[1].tdPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元,首小时后<input v-model="formRule.params[1].tdHoursPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/半小时</td>
						</tr>

						<tr>
							<td>共享</td>
							<td></td>
							<td>
								<el-time-picker
									:editable="false"
								    is-range
								    v-model="formRule.params[2].StartOrEndTime"
								    value-format="HH:mm" 
								    format="HH:mm"
								    range-separator="-"
								    start-placeholder=""
								    end-placeholder=""
								    placeholder="">
								</el-time-picker>
							</td>
							<td>首小时<input v-model="formRule.params[2].firstPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元,首小时后<input v-model="formRule.params[2].firstHoursPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/半小时（超出共享时段<input v-model="formRule.params[2].odLastPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/时）</td>
						</tr>
						<tr>
							<td colspan="4" style="text-align: left;">说明：进场<input v-model="formRule.freeTime" type="text" class="time-input" maxlength="3" @keyup="handleKeyupTime($event)" @afterpaste="handleAfterpasteTime($event)">分钟内免费;
								<div>
									月卡：小车<input v-model="formRule.params[0].monthsCardPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/月&nbsp;&nbsp;大车<input v-model="formRule.params[1].monthsCardPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元/月&nbsp;&nbsp;开关：<el-switch v-model="formRule.openFlag" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
								</div>
							</td>
						</tr>
					</table> -->

					<!-- 路侧 1-->
					<table class="table-rule">
						<tr>
							<td rowspan="2">小车</td>
							<td>工作日</td>
							<td>
								<el-time-picker
									:editable="false"
								    is-range
								    v-model="formRuleOne.params[0].wdStartOrEndTime"
								    value-format="HH:mm" 
								    format="HH:mm"
								    range-separator="-"
								    start-placeholder=""
								    end-placeholder=""
								    placeholder="">
								</el-time-picker>
							</td>
							<td>首<input v-model="formRuleOne.params[0].wdAfterHourF" type="text" class="time-input" maxlength="3" @keyup="handleKeyupTime($event)" @afterpaste="handleAfterpasteTime($event)">小时<input v-model="formRuleOne.params[0].wdFirstPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元，{{formRuleOne.params[0].wdAfterHourF}} - {{formRuleOne.params[0].wdLastHour}} 小时<input v-model="formRuleOne.params[0].wdAfterPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元，<input v-model="formRuleOne.params[0].wdLastHour" type="text" class="time-input" maxlength="3" @keyup="handleKeyupTime($event)" @afterpaste="handleAfterpasteTime($event)">小时后<input v-model="formRuleOne.params[0].wdLastPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元</td>
						</tr>
						<tr>
							<td>非工作日</td>
							<td>
								<el-time-picker
									:editable="false"
								    is-range
								    v-model="formRuleOne.params[0].odStartOrEndTime"
								    value-format="HH:mm" 
								    format="HH:mm"
								    range-separator="-"
								    start-placeholder=""
								    end-placeholder=""
								    placeholder="">
								</el-time-picker>
							</td>
							<td>首<input v-model="formRuleOne.params[0].odAfterHourF" type="text" class="time-input" maxlength="3" @keyup="handleKeyupTime($event)" @afterpaste="handleAfterpasteTime($event)">小时<input v-model="formRuleOne.params[0].odFirstPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元，{{formRuleOne.params[0].odAfterHourF}} - {{formRuleOne.params[0].odLastHour}} 小时<input v-model="formRuleOne.params[0].odAfterPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元，<input v-model="formRuleOne.params[0].odLastHour" type="text" class="time-input" maxlength="3" @keyup="handleKeyupTime($event)" @afterpaste="handleAfterpasteTime($event)">小时后<input v-model="formRuleOne.params[0].odLastPrice" type="text" class="money-input" maxlength="5" @keyup="handleKeyup($event)" @afterpaste="handleAfterpaste($event)">元</td>
						</tr>
						<tr>
							<td colspan="4" style="text-align: left;">说明：进场<input v-model="formRuleOne.freeTime" type="text" class="time-input" maxlength="3" @keyup="handleKeyupTime($event)" @afterpaste="handleAfterpasteTime($event)">分钟内免费收费规则（元/半小时）</td>
						</tr>
					</table>

				</el-form>
		  	</div>

		  	<div slot="footer" class="dialog-footer">
		    	<el-button @click="dialogFormVisibleRule = false">取 消</el-button>
		    	<el-button type="primary" @click="addrOrEditRuleTrue">确 定</el-button>
		  	</div>
		</el-dialog>
</div>
    
</template>
<script>
import {getChargeRule} from  '@/api/url'
export default{
    data(){
        return{
			formLabelWidth:'100px',
			  //室外1
		        formRuleOne:{
		        	chargeRuleId:'',
		        	parkingId:'',
		        	freeTime:'',
		        	params:[{
		        		lrId:'',
		        		carType:'auto',
		        		wdStartOrEndTime:['00:00','00:00'],
		        		wdAfterHourF:'',
		        		wdLastHour:'',

		        		wdFirstPrice:'',
		        		wdAfterPrice:'',
		        		wdLastPrice:'',
		        		wdFreeMin:'',

		        		odStartOrEndTime:['00:00','00:00'],
		        		odAfterHourF:'',
		        		odLastHour:'',

		        		odFirstPrice:'',
		        		odAfterPrice:'',
		        		odLastPrice:'',
		        		odFreeMin:''

		        	}]
		        },
		    dialogFormVisibleRule:false,    
		}
		
    },
  
    methods:{
        		getChargeRule:function(parkId,objCharge){
				this.dialogFormVisibleRule=true;
			
				var chargeRuleId=JSON.parse(objCharge).id;
				if(chargeRuleId=='3'){
					this.matchRuleStype=true;
					this.formRule.chargeRuleId=chargeRuleId;
					this.formRule.parkingId=parkId;
				}else if(chargeRuleId=='1'){
					this.matchRuleStype=false;
					this.formRuleOne.chargeRuleId=chargeRuleId;
					this.formRuleOne.parkingId=parkId;
				}
				this.$get(getChargeRule(),{
					parkingId:parkId,
					chargeRuleId:chargeRuleId
				}).then((data) => {
					if(data.status!=200) return;
					var result=data.data;
					if(chargeRuleId=='3'){
						for(var i=0;i<result.length;i++){
							if(result[i].carType=='auto'){
								this.formRule.freeTime=result[i].freeTime;
								this.formRule.openFlag=result[i].openFlag=='y'?true:false;

								for(var k in result[i]){
									this.formRule.params[0][k]=result[i][k];
								}

								this.formRule.params[0].StartOrEndTime=[result[i].firstStartTime,result[i].firstEndTime];
								

							}else if(result[i].carType=='truck'){
								this.formRule.params[1]=result[i];
							}else if(result[i].carType=='private'){

								for(var k in result[i]){
									this.formRule.params[2][k]=result[i][k];
								}
								
								this.formRule.params[2].StartOrEndTime=[result[i].firstStartTime,result[i].firstEndTime];
							}
						}
					}else if(chargeRuleId=='1'){

						for(var i=0;i<result.length;i++){
							if(result[i].carType=='auto'){
								this.formRuleOne.freeTime=result[i].wdFreeMin;

								for(var k in result[i]){
									this.formRuleOne.params[0][k]=result[i][k];
								}

								this.formRuleOne.params[0].wdStartOrEndTime=[result[i].wdStartTime,result[i].wdEndTime];
								
								this.formRuleOne.params[0].odStartOrEndTime=[result[i].odStartTime,result[i].odEndTime];
							}
						}
					}
				})

			},
			addrOrEditRuleTrue:function(){
				this.dialogFormVisibleRule=false;
				if(this.matchRuleStype){
					this.$postRequest(addOrUpdateChargeRule(),{
						chargeRuleId:this.formRule.chargeRuleId,
						params:[{
							parkingId:this.formRule.parkingId,
							freeTime:this.formRule.freeTime,
			        		carType:this.formRule.params[0].carType,

			        		lrId:this.formRule.params[0].lrId,
			        		openFlag:this.formRule.openFlag?'y':'n',
			        		monthsCardPrice:this.formRule.params[0].monthsCardPrice,
			        		firstStartTime:this.formRule.params[0].StartOrEndTime[0],
			        		firstEndTime:this.formRule.params[0].StartOrEndTime[1],
			        		odStartTime:this.formRule.params[0].StartOrEndTime[1],
			        		odEndTime:this.formRule.params[0].StartOrEndTime[0],

			        		firstHours:'1',
			        		firstPrice:this.formRule.params[0].firstPrice,
			        		firstHoursPrice:this.formRule.params[0].firstHoursPrice,
			        		odLastPrice:this.formRule.params[0].odLastPrice,

			        		tdHours:'1',
			        		tdPrice:this.formRule.params[0].tdPrice,
			        		tdHoursPrice:this.formRule.params[0].tdHoursPrice
			        	},{
							parkingId:this.formRule.parkingId,
							freeTime:this.formRule.freeTime,
			        		carType:this.formRule.params[1].carType,

			        		lrId:this.formRule.params[1].lrId,
			        		openFlag:this.formRule.openFlag?'y':'n',
			        		monthsCardPrice:this.formRule.params[1].monthsCardPrice,
			        		// StartOrEndTime:['00:00','00:00'],
			        		firstStartTime:this.formRule.params[0].StartOrEndTime[0],
			        		firstEndTime:this.formRule.params[0].StartOrEndTime[1],
			        		odStartTime:this.formRule.params[0].StartOrEndTime[1],
			        		odEndTime:this.formRule.params[0].StartOrEndTime[0],

			        		firstHours:'1',
			        		firstPrice:this.formRule.params[1].firstPrice,
			        		firstHoursPrice:this.formRule.params[1].firstHoursPrice,
			        		odLastPrice:this.formRule.params[1].odLastPrice,

			        		tdHours:'1',
			        		tdPrice:this.formRule.params[1].tdPrice,
			        		tdHoursPrice:this.formRule.params[1].tdHoursPrice
			        	},{
							parkingId:this.formRule.parkingId,
							freeTime:this.formRule.freeTime,
			        		carType:this.formRule.params[2].carType,

			        		lrId:this.formRule.params[2].lrId,
			        		// StartOrEndTime:['00:00','00:00'],
			        		firstStartTime:this.formRule.params[2].StartOrEndTime[0],
			        		firstEndTime:this.formRule.params[2].StartOrEndTime[1],
			        		odStartTime:this.formRule.params[2].StartOrEndTime[1],
			        		odEndTime:this.formRule.params[2].StartOrEndTime[0],

			        		firstHours:'1',
			        		firstPrice:this.formRule.params[2].firstPrice,
			        		firstHoursPrice:this.formRule.params[2].firstHoursPrice,
			        		odLastPrice:this.formRule.params[2].odLastPrice
			        	}]

					}).then((data) => {
	    				if(data.status!=200) return ;

	  				});
  				}else{
  					this.$postRequest(addOrUpdateChargeRule(),{
						chargeRuleId:this.formRuleOne.chargeRuleId,
						params:[{
							parkingId:this.formRuleOne.parkingId,
			        		carType:this.formRuleOne.params[0].carType,

			        		lrId:this.formRuleOne.params[0].lrId,

			        		wdStartTime:this.formRuleOne.params[0].wdStartOrEndTime[0],
			        		wdEndTime:this.formRuleOne.params[0].wdStartOrEndTime[1],

			        		wdAfterHourF:this.formRuleOne.params[0].wdAfterHourF,
			        		wdFirstHour:this.formRuleOne.params[0].wdAfterHourF,
			        		wdAfterHourL:this.formRuleOne.params[0].wdLastHour,
			        		wdLastHour:this.formRuleOne.params[0].wdLastHour,

			        		wdFirstPrice:this.formRuleOne.params[0].wdFirstPrice,
			        		wdAfterPrice:this.formRuleOne.params[0].wdAfterPrice,
			        		wdLastPrice:this.formRuleOne.params[0].wdLastPrice,
			        		wdFreeMin:this.formRuleOne.freeTime,

			        		odStartTime:this.formRuleOne.params[0].odStartOrEndTime[0],
			        		odEndTime:this.formRuleOne.params[0].odStartOrEndTime[1],

			        		odAfterHourF:this.formRuleOne.params[0].odAfterHourF,
			        		odFirstHour:this.formRuleOne.params[0].odAfterHourF,
			        		odAfterHourL:this.formRuleOne.params[0].odLastHour,
			        		odLastHour:this.formRuleOne.params[0].odLastHour,

			        		odFirstPrice:this.formRuleOne.params[0].odFirstPrice,
			        		odAfterPrice:this.formRuleOne.params[0].odAfterPrice,
			        		odLastPrice:this.formRuleOne.params[0].odLastPrice,
			        		odFreeMin:this.formRuleOne.freeTime

			        	}]

					}).then((data) => {
	    				if(data.status!=200) return ;

	  				});
  				}
			},
			
			openDialogRule:function(){},
			closeDialogRule:function(){
				this.$refs['formRule'].resetFields();

				// 室内3
		        this.formRule={
		        	chargeRuleId:'',
		        	parkingId:'',
		        	openFlag:false,
		        	freeTime:'',
		        	params:[{
		        		lrId:'',
		        		carType:'auto',
		        		StartOrEndTime:['00:00','00:00'],
		        		firstHours:'1',
		        		firstPrice:'',
		        		firstHoursPrice:'',
		        		odLastPrice:'',

		        		tdHours:'1',
		        		tdPrice:'',
		        		tdHoursPrice:'',
		        		monthsCardPrice:''
		        	},{
		        		lrId:'',
		        		carType:'truck',
		        		firstHours:'1',
		        		firstPrice:'',
		        		firstHoursPrice:'',
		        		odLastPrice:'',

		        		tdHours:'1',
		        		tdPrice:'',
		        		tdHoursPrice:'',
		        		monthsCardPrice:''
		        	},{
		        		lrId:'private',
		        		carType:'',
		        		StartOrEndTime:['00:00','00:00'],

		        		firstHours:'1',
		        		firstPrice:'',
		        		firstHoursPrice:'',
		        		odLastPrice:'',
		        		monthsCardPrice:''
		        	}]
		        };

		        //室外1
		        this.formRuleOne={
		        	chargeRuleId:'',
		        	parkingId:'',
		        	freeTime:'',
		        	params:[{
		        		lrId:'',
		        		carType:'auto',
		        		wdStartOrEndTime:['00:00','00:00'],
		        		wdAfterHourF:'',
		        		wdLastHour:'',

		        		wdFirstPrice:'',
		        		wdAfterPrice:'',
		        		wdLastPrice:'',
		        		wdFreeMin:'',

		        		odStartOrEndTime:['00:00','00:00'],
		        		odAfterHourF:'',
		        		odLastHour:'',

		        		odFirstPrice:'',
		        		odAfterPrice:'',
		        		odLastPrice:'',
		        		odFreeMin:''

		        	}]
		        };

			},
    }


}
</script>
<style scoped>
	.table-rule {
		color: #222;
	    border-spacing: 0;
	    border-collapse: collapse;
	}
	.table-rule tr td {
		padding:10px 10px;
	    text-align: center;
	    border: 1px solid #ccc;
	    font-size: 14px;
	}

	.table-rule .money-input,.table-rule .time-input{
		width: 40px;
	    height: 26px;
	    border: 1px solid #ccc;
	    /* border: 1px solid #02c1af; */
	    border-radius: 2px;
	    text-align: center;
	    color: #222;
	    color: #02c1af;
	}
</style>